import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, isLoggedIn, isVerifyEmail, isProvider, userToken, logout} from "../../features/user";
import { setLoading, showMessage } from "../../features/common";
import axios from "axios";
import { API_204, API_201, API_404, API_URL, DEFAULT_ERROR_TEXT } from '../../Constants';
import {Trans, useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage,checkValidToken, getLang} from "../../Helper"

import cookie from "js-cookie";
import Frame from '../widgets/Frame';
import Background from '../widgets/Background';
import Input from '../widgets/Input';

export function VerifyEmail() {
    const [state, setState] = useState({ code: "", errors: {}, message: null });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);
    const isUserProvider = useSelector(isProvider);
    
    useEffect(() => {
        let errorMessage = cookie.get('logout_error');
        if(errorMessage !== "null" && (typeof errorMessage !== 'undefined')){
            setState({
                ...state,
                errors: {server_error: errorMessage},
                message: null
            });
            cookie.set('logout_error', "null", { sameSite: 'strict' });
        }
        // eslint-disable-next-line
      }, []);

    useEffect(()=>{
        if(isUserLoggedIn){
            console.log("isUserLoggedIn = true");
            checkValidToken(navigate, dispatch, logout);
        } else if(!isUserVerifyEmail) {
            navigate('/start');
        }
        // eslint-disable-next-line
    },[]);

    const handleNumberChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'),
            errors: {},
            message: null
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            setState({
                ...state,
                errors: {},
                message: null
            });
            let errorMessage = t(DEFAULT_ERROR_TEXT);
          
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {validateEmailCode: state.code.trim()};

            try {
                const reply = await axios.patch(`${API_URL }${(isUserProvider?'/providers':'/users')}/verifyemail`, data, config);
                if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_201
                        && reply.data.hasOwnProperty('accessToken')){
                    dispatch(login({token : reply.data.accessToken, userType:isUserProvider?'provider':null}));
                        if(isUserProvider) {
                            navigate("/provider-required-info");
                        } else {
                            navigate("/writer-questionnaire");
                        }


                }
            } catch (e) {
                if(e.response?.status === API_404) {
                    errorMessage = 'validate_email_error';
                } else if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                    setState({
                        ...state,
                        message: null
                    });
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }
    };

    const resendCodeClick = async () => {
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }${(isUserProvider?'/provider':'/user')}/resendcode`, config);
            if(reply.hasOwnProperty('status') && reply.status === API_204) {
                setState({
                    ...state,
                    errors: {},
                    message: "A new verification code sent to your email"
                }); 
            } 
        } catch (e) {
            setState({
                ...state,
                message: null
            });
            dispatch(showMessage({message : errorMessage}));
        }

    };


    const validateForm = () => {
        const errors = {};
        if (!state.code?.trim()) {
            errors['code'] = 'verification_code_error';
        }

        setState({
            ...state,
            errors: errors,
            message: null
        });

        return Object.keys(errors).length > 0;
    };


    return (
        <Frame show={state.show} showBack={false}>
            <div className='main main-login'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        <Background showClouds={true}>
                            <div className='right-main-inner'>
                                <div className='mt20 text-align-center font-19'>{t("validate_email_title")}</div> 
                                <div className='mt30'>
                                    <Input className={state.errors.code?"error":""} id="code" placeholder={t("verification_code")} value={state.code??''} onChange={(e) => handleNumberChange(e)}/>
                                </div>
                                {state.errors.code && <div className='mt5 error font-12'><Trans i18nKey={state.errors.code} /></div>}

                                <div className='mt40 mr30 text-align-right font-11 font-underline color-550952' onClick={(e) => resendCodeClick(e)}><Trans i18nKey="resend_code" /></div> 
                                {state.message && <div className='mt5'><Trans i18nKey={state.message} /></div>}
                                <div className='button mt20' onClick={(e) => handleSubmit(e)}>  <div>{t("verify_email")}</div> </div>
                            </div>
                        </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}